export const FeatureTabs = {
  PRODUCTS: 'planos',
  PAYMENT_LINK: 'link_de_contratacao',
  REGISTRATION_LINK: 'link_de_cadastro',
  CONTRACTS: 'contratos',
  CHARGES: 'cobrancas',
  INSTALLMENTS: 'parcelamentos',
  RECURRENCES: 'recorrencias',
  TRANSFERS: 'transferencias',
  NFS: 'nfse',
  NEGATIVATION: 'negativacao',
  NOTIFICATIONS: 'notificacoes',
  GROUPS: 'grupos',
  CUSTOMERS: 'clientes',
  ACCOUNTS_RECEIVABLE: 'contas-a-receber',
  ACCOUNTS_PAYABLE: 'contas-a-pagar',
  COMMUNICATION: 'comunicacao',
  WHATSAPP_BUSINESS: 'whatsapp_business',
  PORTAL: 'portal',
  REPORTS: 'relatorios',
  IMPORTS: 'imports',
  TRACKING: 'rastreamento',
  ANALYSIS: 'analise_financeira',
  SALES_PAGE: 'pagina_de_venda',
  WORKFLOW: 'workflow',
  CASH_FLOW: 'fluxo-de-caixa',
  DRE: 'dre',
  BANK_RECONCILIATION: 'conciliacao-bancaria'
}

export const ReceivablesTabs = Object.freeze({
  CALENDAR_RECEIVABLES: 'calendario_recebiveis',
  RECEIVABLES: 'saldo_liberado',
  ANTECIPATIONS: 'antecipacoes',
  CONTESTS: 'contestacoes'
})

export const settingsTabsParams = {
  PROFILE: 'perfil',
  CHANGE_PASSWORD: 'alterar-senha',
  NOTIFICATIONS: 'notificacoes',
  BILLING_RULE: 'regua-de-cobranca',
  USERS: 'usuarios',
  EXTRA_FIELDS: 'campos-extras',
  CUSTOMIZE_PORTAL: 'personalizar-portal',
  BANK_ACCOUNTS: 'contas-bancarias',
  TAGS: 'tags',
  IMPORTS: 'importacoes',
  MY_PLAN: 'meu-plano',
  MY_FEES: 'minhas-taxas',
  CREDIT_CARD_PLANS: 'plano-de-recebimento',
  TRACKING: 'rastreamento',
  WEBHOOKS: 'webhooks',
  CORA_BANK: 'banco-cora',
  INTEGRATIONS: 'integracoes',
  REFERRALS: 'indicacoes'
}

export const notificacoesHubTabsParams = {
  OVERVIEW: 'visao-geral',
  WHATSAPP_BUSINESS: 'whatsapp-business',
  EMAIL_PROPRIO: 'email-proprio',
  REGUA_COBRANCA: 'regua-de-cobranca'
}

export enum notificacoesHubTabsNumbers {
  OVERVIEW = 0,
  WHATSAPP_BUSINESS,
  EMAIL_PROPRIO,
  REGUA_COBRANCA
}

export enum settingsTabsNumbers {
  PROFILE = 0,
  CHANGE_PASSWORD,
  NOTIFICATIONS,
  BILLING_RULE,
  USERS,
  EXTRA_FIELDS,
  CUSTOMIZE_PORTAL,
  BANK_ACCOUNTS,
  TAGS,
  IMPORTS,
  TRACKING,
  MY_PLAN,
  MY_FEES,
  WEBHOOKS,
  CORA_BANK,
  INTEGRATIONS,
  // Sempre no fim: o valor é posicional e o `tab` viaja na URL (?tab=indicacoes),
  // então inserir no meio renumeraria as abas já linkadas por aí.
  REFERRALS,
  CREDIT_CARD_PLANS
}
